module.exports = __webpack_public_path__ + "fonts/VetoSansCond-Italic.33a34463.woff";